<script setup lang="ts">
import type LandingSection from '@store/content/entities/LandingSection';

defineProps<{
    content: LandingSection;
}>();
</script>

<template>
    <div
        class="information-section"
        :style="{ backgroundColor: content.backgroundColor }"
    >
        <div
            class="container"
            :class="{ 'image-left': content.imagePosition === 'Left' }"
        >
            <img
                v-if="content.image"
                :src="content.image.src"
                :alt="content.image.alt"
                class="information-img"
            />
            <div class="content" v-html="content.content" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.information-section {
    padding: 20px 0 48px 0;
    @media (max-width: $app-mobile-max-width) {
        padding-block: 64px;
    }
    @include mobile-only(1232px) {
        padding-inline: 16px;
    }
    .container {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto !important;
        display: flex;
        align-items: flex-start;
        gap: 100px;
        @media (max-width: $app-mobile-max-width) {
            gap: 40px;
        }
        &.image-left {
            flex-direction: row-reverse;
        }
        @media (max-width: $app-mobile-max-width) {
            flex-direction: column !important;
        }
    }
    .information-img {
        object-fit: contain;
        flex-shrink: 0;
        border-radius: 16px;
        width: 488px;
        @include mobile-only {
            width: 100%;
        }
    }
    :deep() {
        h2 {
            @include font-weight(bold);
            color: usePalette($p-cool-gray, $p-800);
            margin: 0 !important;
        }
        p {
            padding-top: 24px;
            @include tg-s($color: usePalette($p-cool-gray, $p-800));
            text-align: justify;
            text-overflow: ellipsis;
            margin: 0;
        }
        b,
        strong {
            @include font-weight(bold);
        }

        li {
            display: list-item;
            padding-block: 1px;
        }

        ol {
            display: block;
            list-style: decimal;
            margin: 1em 0;
            padding-right: 40px;
            text-align: justify;
        }

        ul {
            display: block;
            list-style: disc;
            margin: 1em 0;
            padding-right: 40px;
        }
    }
}
</style>
